export default {
	topicCount: "{count} topics",
	applyButton: "Apply",
	previewButton: "Preview",
	recentBadge: "RECENT",
	customBadge: "CUSTOM",
};
